var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiftCard1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 52,
    viewBox: "0 0 72 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H72V52H0z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#DA1C5C"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.058 5.037L23.465 5.037 20.686 19.907 4.843 19.907zM0 0H25.185V5.037H0z",
    transform: "translate(2 9) translate(42.81) translate(0 9.57)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.192 8.2c2.864-.21 4.716-.728 5.556-1.554 1.259-1.24 1.405-3.105.325-4.167-1.079-1.062-2.974-.919-4.234.32C9 3.625 8.451 5.425 8.192 8.2zM7.862 8.218c-2.513-.12-4.19-.592-5.029-1.418-1.259-1.24-1.405-3.105-.326-4.167 1.08-1.062 2.975-.919 4.234.32.84.827 1.213 2.582 1.12 5.265z",
    transform: "translate(2 9) translate(42.81) translate(5.042)"
  }))), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M49.801 32.128c-.907.885-2.147 1.43-3.515 1.43H5.037C2.255 33.558 0 31.302 0 28.52V5.037C0 2.255 2.255 0 5.037 0h41.25c.666 0 1.302.13 1.884.365",
    transform: "translate(2 9)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.961 12.337L38.473 12.337M11.35 2.961L11.35 31.584",
    transform: "translate(2 9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.324 12.135c1.961-.17 3.23-.547 3.808-1.13.866-.873.966-2.189.224-2.938-.742-.748-2.046-.647-2.912.226-.578.583-.951 1.863-1.12 3.842zM11.324 12.382c.169 1.979.542 3.26 1.12 3.842.866.873 2.17.975 2.912.226.742-.75.642-2.064-.224-2.938-.577-.583-1.847-.96-3.808-1.13zM10.604 12.135c-1.962-.17-3.231-.547-3.809-1.13-.866-.873-.966-2.189-.224-2.938.743-.748 2.047-.647 2.913.226.577.583.95 1.863 1.12 3.842zM10.604 12.382c-.17 1.979-.543 3.26-1.12 3.842-.866.873-2.17.975-2.913.226-.742-.75-.642-2.064.224-2.938.578-.583 1.847-.96 3.809-1.13z",
    transform: "translate(2 9)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18.48 18.259L41.181 18.259M18.48 22.207L41.181 22.207M18.48 26.155L32.298 26.155",
    transform: "translate(2 9)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M56.5 11L56.5 29",
    transform: "translate(2 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftCard1);
export default __webpack_public_path__ + "static/media/giftCard1.74b842ec1e537aacb77a50a458c8dc6f.svg";
export { ForwardRef as ReactComponent };